/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhoneRequest
 */
export interface PhoneRequest {
    /**
     * 
     * @type {string}
     * @memberof PhoneRequest
     */
    authenticationToken: string;
    /**
     * 
     * @type {string}
     * @memberof PhoneRequest
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof PhoneRequest
     */
    password?: string;
}

/**
 * Check if a given object implements the PhoneRequest interface.
 */
export function instanceOfPhoneRequest(value: object): value is PhoneRequest {
    if (!('authenticationToken' in value) || value['authenticationToken'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    return true;
}

export function PhoneRequestFromJSON(json: any): PhoneRequest {
    return PhoneRequestFromJSONTyped(json, false);
}

export function PhoneRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'authenticationToken': json['authenticationToken'],
        'number': json['number'],
        'password': json['password'] == null ? undefined : json['password'],
    };
}

export function PhoneRequestToJSON(value?: PhoneRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'authenticationToken': value['authenticationToken'],
        'number': value['number'],
        'password': value['password'],
    };
}

